import { ColumnSelectorProps, GetFullFMDQLabel } from "@/src/common/types"
import Checkbox from "@/src/sb/components/CustomCheckbox"
import Card from "@/src/sb/components/FMDQTable/Card"
import DynamicSelect from "@/src/sb/components/FMDQTable/DynamicSelect"
import React from "react"

const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  columns,
  checkboxState,
  handleCardDisplay,
  handleCheckboxChange,
  handleApplyColumns,
  handleCloseColumns,
  showCard,
  handleResetColumns
}) => {
  const getFullLabel: GetFullFMDQLabel = (key, label, columns) => {
    if (key.endsWith("_percent_change")) {
      const baseKey = key.replace("_percent_change", "")
      const baseLabel = columns.find((col) => col.key === baseKey)?.label || ""
      return `${baseLabel} % CHG`
    } else {
      return label
    }
  }

  return (
    <div className="relative">
      <DynamicSelect
        placeholder="Display columns"
        onClick={handleCardDisplay}
      />

      {showCard && (
        <Card
          onClose={handleCloseColumns}
          className="absolute"
          onApply={handleApplyColumns}
          showCard={showCard}
        >
          <section className="flex items-center justify-between py-2 px-5 text-xs font-normal border-b-[0.5px] dark:border-[#4B5563]">
            <span className="text-white">Select Columns</span>
            <span
              className="underline text-[#9CA3AF] cursor-pointer"
              onClick={handleResetColumns}
            >
              Reset
            </span>
          </section>
          <div className="h-[200px] overflow-y-auto flex flex-col gap-[15.5px] py-[2px] px-5 mt-2">
            {columns.map((data) => (
              <div key={data.key} className="">
                <Checkbox
                  id={data.key}
                  checked={checkboxState[data.key] || false}
                  onChange={(e: any) =>
                    handleCheckboxChange(data.key, e.target.checked)
                  }
                  label={getFullLabel(data.key, data.label, columns)}
                />
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  )
}

export default ColumnSelector
